module.exports = __webpack_public_path__ + "static/media/exclamation.5a386d84.svg";